import { Badge, BadgeProps } from '@mantine/core';
import colors from 'common/constants/colors.styles';
import {
  ApprovalItemStatusEnum,
  ApprovalVerdictStatusEnum,
  BonusPeriodStatusEnum,
  ChequeNoteClearingStatusEnum,
  ChequeNoteStatusEnum,
  CommissionFilterStatusEnum,
  DocumentSaleGuestDetailStatusEnum,
  DocumentSaleStatusEnum,
  ExpenseIncomeStatusEnum,
  FlightCheckInStatusEnum,
  HotelCheckInStatusEnum,
  InvoicePaymentStatusEnum,
  MutationStatusEnum,
  PaymentStatusEnum,
  ProjectStatusEnum,
  PurchaseStatusEnum,
  ReceiptStatusEnum,
  RefundStatusEnum,
  ReleaseStatusEnum,
  SaleProjectStatusEnum,
  SalePurchaseGuestStatusEnum,
  SaleStatusEnum,
  TourFlightHotelStatusEnum,
  TourStatusEnum,
  TransactionalStatusEnum,
  UserStatusEnum,
} from 'common/constants/enum';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

interface UniskaiStatusBadgesProps {
  status:
    | ApprovalItemStatusEnum
    | ApprovalVerdictStatusEnum
    | BonusPeriodStatusEnum
    | FlightCheckInStatusEnum
    | HotelCheckInStatusEnum
    | ChequeNoteClearingStatusEnum
    | ChequeNoteStatusEnum
    | CommissionFilterStatusEnum
    | DocumentSaleGuestDetailStatusEnum
    | DocumentSaleStatusEnum
    | ExpenseIncomeStatusEnum
    | InvoicePaymentStatusEnum
    | MutationStatusEnum
    | PaymentStatusEnum
    | ProjectStatusEnum
    | PurchaseStatusEnum
    | ReceiptStatusEnum
    | RefundStatusEnum
    | ReleaseStatusEnum
    | SaleProjectStatusEnum
    | SalePurchaseGuestStatusEnum
    | SaleStatusEnum
    | TourFlightHotelStatusEnum
    | TourStatusEnum
    | TransactionalStatusEnum
    | UserStatusEnum;
  badgeProps?: BadgeProps;
}

export default function UniskaiStatusBadges(props: UniskaiStatusBadgesProps) {
  const { badgeProps } = props;
  const { t } = useTranslation();
  const _props = React.useMemo(() => {
    switch (props.status) {
      case ApprovalItemStatusEnum.Pending:
        return {
          color: colors.yellow,
        };
      case ApprovalItemStatusEnum.Approved:
        return {
          color: colors.green,
        };
      case ApprovalItemStatusEnum.Rejected:
        return {
          color: colors.red,
        };
      case BonusPeriodStatusEnum.Issued:
        return {
          color: colors.gray,
        };
      case FlightCheckInStatusEnum.NotCheckedIn:
        return {
          color: colors.yellow,
        };
      case FlightCheckInStatusEnum.NotAvailable:
        return {
          color: colors.gray,
        };
      case FlightCheckInStatusEnum.SeatOk:
        return {
          color: colors.green,
        };
      case FlightCheckInStatusEnum.CheckedIn:
        return {
          color: colors.green,
        };
      case ChequeNoteClearingStatusEnum.Cleared:
        return {
          color: colors.green,
        };
      case ChequeNoteStatusEnum.Archived:
        return {
          color: colors.gray,
        };
      case ChequeNoteStatusEnum.Created:
        return {
          color: colors.yellow,
        };
      case ChequeNoteStatusEnum.Void:
        return {
          color: colors.brown,
        };
      case CommissionFilterStatusEnum.Active:
        return {
          color: colors.green,
        };
      case CommissionFilterStatusEnum.Inactive:
        return {
          color: colors.gray,
        };
      case CommissionFilterStatusEnum.Upcoming:
        return {
          color: colors.yellow,
        };
      case DocumentSaleGuestDetailStatusEnum.Completed:
        return {
          color: colors.gray,
        };
      case DocumentSaleStatusEnum.Processed:
        return {
          color: colors.yellow,
        };
      case DocumentSaleStatusEnum.Submitted:
        return {
          color: colors.green,
        };
      case DocumentSaleStatusEnum.Finished:
        return {
          color: colors.gray,
        };
      case DocumentSaleStatusEnum.Canceled:
        return {
          color: colors.gray,
        };
      case DocumentSaleStatusEnum.RevertToSubmittedDraft:
        return {
          color: colors.brown,
        };
      case DocumentSaleStatusEnum.PendingRevertToSubmittedApproval:
        return {
          color: colors.yellow,
        };
      case DocumentSaleStatusEnum.RevertToProcessedDraft:
        return {
          color: colors.yellow,
        };
      case DocumentSaleStatusEnum.PendingRevertToProcessedApproval:
        return {
          color: colors.brown,
        };
      case ExpenseIncomeStatusEnum.Draft:
        return {
          color: colors.yellow,
        };
      case ExpenseIncomeStatusEnum.Waiting:
        return {
          color: colors.yellow,
        };
      case ExpenseIncomeStatusEnum.PendingApproval:
        return {
          color: colors.yellow,
        };
      case ExpenseIncomeStatusEnum.RejectedApproval:
        return {
          color: colors.red,
        };
      case ExpenseIncomeStatusEnum.VoidDraft:
        return {
          color: colors.yellow,
        };
      case ExpenseIncomeStatusEnum.PendingVoidApproval:
        return {
          color: colors.yellow,
        };
      case InvoicePaymentStatusEnum.Refund:
        return {
          color: colors.brown,
        };
      case MutationStatusEnum.Valid:
        return {
          color: colors.green,
        };
      case ProjectStatusEnum.CancelDraft:
        return {
          color: colors.yellow,
        };
      case ProjectStatusEnum.PendingCancelApproval:
        return {
          color: colors.yellow,
        };
      case PurchaseStatusEnum.RevertVoidDraft:
        return {
          color: colors.brown,
        };
      case PurchaseStatusEnum.PendingRevertVoidApproval:
        return {
          color: colors.brown,
        };
      case RefundStatusEnum.DraftCancel:
        return {
          color: colors.yellow,
        };
      case RefundStatusEnum.PendingCancel:
        return {
          color: colors.yellow,
        };
      case RefundStatusEnum.Cancel:
        return {
          color: colors.gray,
        };
      case ReleaseStatusEnum.DraftRefund:
        return {
          color: colors.yellow,
        };
      case ReleaseStatusEnum.PendingRefund:
        return {
          color: colors.yellow,
        };
      case ReleaseStatusEnum.RejectRefund:
        return {
          color: colors.red,
        };
      case ReleaseStatusEnum.DraftCancelRefund:
        return {
          color: colors.yellow,
        };
      case ReleaseStatusEnum.PendingCancelRefund:
        return {
          color: colors.yellow,
        };
      case ReleaseStatusEnum.CancelRefund:
        return {
          color: colors.gray,
        };
      case ReleaseStatusEnum.Requested:
        return {
          color: colors.green,
        };
      case ReleaseStatusEnum.PendingReleaseApproval:
        return {
          color: colors.yellow,
        };
      case ReleaseStatusEnum.RejectedReleaseApproval:
        return {
          color: colors.green,
        };
      case SaleProjectStatusEnum.None:
        return {
          color: colors.gray,
        };
      case SaleProjectStatusEnum.DraftRemoval:
        return {
          color: colors.yellow,
        };
      case SaleProjectStatusEnum.PendingRemoval:
        return {
          color: colors.yellow,
        };
      case SalePurchaseGuestStatusEnum.Rescheduling:
        return {
          color: colors.yellow,
        };
      case SalePurchaseGuestStatusEnum.Rescheduled:
        return {
          color: colors.green,
        };
      case SalePurchaseGuestStatusEnum.RejectedReschedule:
        return {
          color: colors.red,
        };
      case SalePurchaseGuestStatusEnum.RefundedRefunding:
        return {
          color: colors.yellow,
        };
      case SalePurchaseGuestStatusEnum.Refunding:
        return {
          color: colors.yellow,
        };
      case SalePurchaseGuestStatusEnum.Refunded:
        return {
          color: colors.brown,
        };
      case SaleStatusEnum.OpenTicket:
        return {
          color: colors.yellow,
        };
      case SaleStatusEnum.RescheduleDraft:
        return {
          color: colors.yellow,
        };
      case SaleStatusEnum.PendingRescheduleApproval:
        return {
          color: colors.yellow,
        };
      case SaleStatusEnum.RejectedRescheduleApproval:
        return {
          color: colors.red,
        };
      case TourStatusEnum.CloseDraft:
        return {
          color: colors.yellow,
        };
      case TourStatusEnum.PendingCloseApproval:
        return {
          color: colors.yellow,
        };
      case TourStatusEnum.Closed:
        return {
          color: colors.gray,
        };
      case TourStatusEnum.RevertCloseDraft:
        return {
          color: colors.brown,
        };
      case TourStatusEnum.PendingRevertCloseApproval:
        return {
          color: colors.yellow,
        };
      case UserStatusEnum.Safe:
        return {
          color: colors.green,
        };
      case UserStatusEnum.UnderSurveillance:
        return {
          color: colors.red,
        };
      default:
        return {};
    }
  }, [props.status]);

  return (
    <Badge
      {...badgeProps}
      color={_props.color}
      children={t(`enum:${props.status}`)}
    />
  );
}
